 
const Navbar = () => {
  return (
    <nav className='bg-green-900 shadow-green-900'>
        <div className="wrapper py-5 px-3">
 
        <h3 className="text-4xl text-green-200 text-center font-bold">Books</h3>
 
        </div>
    </nav>
  )
}

export default Navbar